import type { CheckInEnhance } from '@/types/growth'
import BaseModule from '../../BaseModule'
import logger from '../../config/logger'
import GrowthService from './Service'

class Growth extends BaseModule {
  public static override clazz = 'Growth'

  public service!: GrowthService

  public override run(): void {
    logger.log(`run module ${Growth.clazz}`)

    this.service = new GrowthService(this.context)
  }

  /**
   * 获取签到列表增强
   * @returns 签到列表
   */
  public async getCheckinListEnhance(): Promise<CheckInEnhance> {
    const { data } = await this.service.getCheckinList()
    const res: CheckInEnhance = {
      todayDone: true,
      todayId: 0,
      items: data
    }

    // 判断是否还有可签到项
    res.todayDone = data.every(item => item.status !== 1)

    res.todayId =
      [...data].reverse().find(item => item.status === 1)?.id ??
      [...data].reverse().find(item => item.status === 2)?.id ??
      data[0]?.id ??
      0

    return res
  }
}

export default Growth
